import AbstractRepository from "@/repositories/AbstractRepository";

export default class TitleRepository extends AbstractRepository {
    protected static resource: string = "ptf-request-title";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "owner.uuid",
    ];
}
